module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('walkthrough-stepper', {
    attrs: {
      "pageTitles": _vm.page_titles,
      "stepperTitle": "RoundTable Configuration"
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var page = ref.page;

        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (page === 0),
            expression: "page === 0"
          }],
          staticClass: "mh3 pa3 flex-grow"
        }, [_c('div', {
          staticClass: "flex justify-center"
        }, [_c('i', {
          staticClass: "fas fa-eye-slash fa-3x ma3"
        })]), _vm._v(" "), _c('div', {
          staticClass: "pl-subheading"
        }, [_vm._v("\n        Turn on "), _c('span', {
          staticClass: "italics"
        }, [_vm._v("Anonymity Mode")]), _vm._v("\n        to allow students to explore ideas in the discussion with secret\n        identities.\n        "), _c('br'), _c('br'), _vm._v("\n        Use the "), _c('i', {
          staticClass: "fas fa-eye mh1"
        }), _vm._v(" button on the left hand side to\n        toggle their real and secret identities.\n      ")])]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (page === 1),
            expression: "page === 1"
          }],
          staticClass: "mh3 pa3 flex-grow"
        }, [_c('div', {
          staticClass: "flex justify-center"
        }, [_c('i', {
          staticClass: "fas fa-clipboard-list fa-3x ma3"
        })]), _vm._v(" "), _c('div', {
          staticClass: "pl-subheading"
        }, [_vm._v("\n        Create rubrics (criteria, definition and scale) to evaluate individual\n        student engagement and provide personalized feedback.\n        "), _c('br'), _c('br'), _vm._v("\n        You are able to assess your students by clicking the\n        "), _c('span', {
          staticClass: "italics"
        }, [_vm._v("Assessment Tab")]), _vm._v(" in their submission.\n      ")])]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (page === 2),
            expression: "page === 2"
          }],
          staticClass: "mh3 pa3 flex-grow"
        }, [_c('div', {
          staticClass: "flex justify-center"
        }, [_c('i', {
          staticClass: "fas fa-map-signs fa-3x ma3"
        })]), _vm._v(" "), _c('div', {
          staticClass: "pl-subheading"
        }, [_vm._v("\n        Use guidance questions to help students practice giving structured and\n        meaningful feedback.\n      ")])])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-636c5da4!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineWalkthrough/pages/onlineWalkthroughConfiguration.vue
// module id = 1337
// module chunks = 61